import React from "react";
import { useDynamicComponentsContext } from "../../context/DynamicComponentsContext";
import AssistanceCreateA from "../Assistances/DynamicComponents/AssistanceCreateA";
import AssistanceCreateB from "../Assistances/DynamicComponents/AssistanceCreateB";
import AssistanceIndexA from "../Assistances/DynamicComponents/AssistanceIndexA";
import AssistanceIndexB from "../Assistances/DynamicComponents/AssistanceIndexB";
import EquipmentCreateA from "../Equipments/DynamicComponents/EquipmentCreateA";
import EquipmentCreateB from "../Equipments/DynamicComponents/EquipmentCreateB";
import EquipmentEditA from "../Equipments/DynamicComponents/EquipmentEditA";
import EquipmentEditB from "../Equipments/DynamicComponents/EquipmentEditB";
import EquipmentIndexA from "../Equipments/DynamicComponents/EquipmentIndexA";
import EquipmentIndexB from "../Equipments/DynamicComponents/EquipmentIndexB";
import AssistanceEditA from "../Assistances/DynamicComponents/AssistanceEditA";
import AssistanceSearchCreateA from "../Assistances/DynamicComponents/AssistanceSearchCreateA";
import AssistanceWorkshopCreateA from "../Assistances/DynamicComponents/AssistanceWorkshopCreateA";
import AssistanceWorkshopListA from "../Assistances/DynamicComponents/AssistanceWorkshopListA";
import AssistanceWorkshopListB from "../Assistances/DynamicComponents/AssistanceWorkshopListB";
import AssistanceSearchCreateB from "../Assistances/DynamicComponents/AssistanceSearchCreateB";
import AssistanceWorkshopCreateB from "../Assistances/DynamicComponents/AssistanceWorkshopCreateB";
import AssistanceEditB from "../Assistances/DynamicComponents/AssistanceEditB";
import { AssistanceDetailsA } from "../Assistances/DynamicComponents/AssistanceDetailsA";
import { AssistanceDetailsB } from "../Assistances/DynamicComponents/AssistanceDetailsB";
import EquipmentsFromClientA from "../Equipments/DynamicComponents/EquipmentsFromClientA";
import EquipmentsFromClientB from "../Equipments/DynamicComponents/EquipmentsFromClientB";
import AssistancesFromClientA from "../Assistances/DynamicComponents/AssistancesFromClientA";
import AssistancesFromClientB from "../Assistances/DynamicComponents/AssistancesFromClientB";
import ClientIndexDefault from "../../pages/client/ClientIndexDefault";
import ClientIndexPHC from "../../pages/client/ClientIndexPHC";
import StatusIndex from "../../pages/status/StatusIndex";
import StatusCreate from "../../pages/status/StatusCreate";
import StatusEditA from "../../pages/status/StatusEditA";
import AssistanceWorkshopListWithDescription from "../Assistances/DynamicComponents/AssistanceWorkshopListWithDescription";

export default function useDynamicComponent(componentGenericName: string, props?: any) {
    const { dynamicComponents } = useDynamicComponentsContext();

    //Componentes que o utilizador pode usar
    const allowedComponents = dynamicComponents;

    //Componentes que existem na aplicação
    const componentMapping = {
        //Assistencias
        AssistanceIndexA,
        AssistanceIndexB,

        AssistanceWorkshopListA,
        AssistanceWorkshopListB,
        AssistanceWorkshopListWithDescription,

        AssistanceEditA,
        AssistanceEditB,

        AssistanceDetailsA,
        AssistanceDetailsB,

        AssistanceCreateA,
        AssistanceCreateB,

        AssistanceSearchCreateA,
        AssistanceSearchCreateB,

        AssistanceWorkshopCreateA,
        AssistanceWorkshopCreateB,

        //Equipamentos
        EquipmentIndexA,
        EquipmentIndexB,

        EquipmentEditA,
        EquipmentEditB,

        EquipmentCreateA,
        EquipmentCreateB,

        EquipmentsFromClientA,
        EquipmentsFromClientB,

        AssistancesFromClientA,
        AssistancesFromClientB,
        
        //Clientes
        ClientIndexDefault,
        ClientIndexPHC,
        //Status
        StatusIndex,
        StatusCreate,
        StatusEditA,
    };

    const allowedComponentsArray = allowedComponents.split(",");
    let componentToRender = "";

    //utilizamos o .every em vez do foreach porque nao queremos percorrer toda a lista
    //apenas até encontrarmos uma correspondencia
    //TODO: Tentar comparar com maiusculas
    allowedComponentsArray.every((allowedComponentName) => {
        if (allowedComponentName.startsWith(componentGenericName)) {
            componentToRender = allowedComponentName;
            return false;
        }

        return true;
    });

    const ComponentToRender: () => JSX.Element = componentMapping[componentToRender as keyof unknown];

    //Se o componente não for encontrado returnamos um elemento vazio
    if (componentToRender === "" || componentToRender === undefined) {
        return <></>;
    }

    return <ComponentToRender {...props} />;
}
